<template>
  <div class="login-container">
    <div class="logo">
      <img src="@/assets/images/radiometer-logo1.png" alt="">
    </div>
    <div class="login-left-container" />
    <div class="login-right-container">
      <h1>丹纳赫诊断平台</h1>
      <div class="login-right-info">
        <span class="account">管理员登录</span>
        <el-form ref="ruleForm" :model="ruleForm" :rules="rules">
          <el-form-item prop="email">
            <el-input v-model="ruleForm.email" placeholder="请输入邮箱">
              <template slot="prepend">
                <img src="https://danaher2021.oss-cn-shanghai.aliyuncs.com/golden/email-icon.png" class="email-icon">
              </template>
            </el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input v-model="ruleForm.password" type="password" placeholder="请输入密码">
              <template slot="prepend">
                <img src="https://danaher2021.oss-cn-shanghai.aliyuncs.com/golden/password-icon.png" class="email-icon">
              </template>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-checkbox v-model="checked">
              记住密码
            </el-checkbox>
          </el-form-item>
          <el-form-item>
            <el-button class="btn" type="primary" @click="submitForm('ruleForm')">
              登录
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { encryption, getDAesString } from '@/utils/crypto'
import { setCookie, getCookie, clearCookie } from '@/utils/tool'
import { login } from '@/api/index'
export default {
  data() {
    return {
      ruleForm: {
        email: '',
        password: ''
      },
      rules: {
        email: [
          { required: true, message: '请输入邮箱号', trigger: 'change' },
          { type: 'email', message: '请输入正确的邮箱号', trigger: 'change' }
        ],
        password: [{ required: true, message: '请输入密码', trigger: 'change' }]
      },
      checked: false
    }
  },
  mounted() {
    if (getCookie('login_p') !== '' && getCookie('login_user') !== '') {
      this.checked = true
      this.ruleForm.email = getCookie('login_user') || ''
      this.ruleForm.password = getDAesString(getCookie('login_p'), 'thanks,pig4cloud')
    } else {
      this.checked = false
    }
  },
  methods: {
    // 登录
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const user = encryption({ data: this.ruleForm, type: '', key: 'thanks,pig4cloud', param: ['password'] })
          const data = {
            username: user.email,
            password: user.password,
            grant_type: 'password',
            scope: 'server'
          }
          login(data).then(res => {
            if (res.code === 1) {
              this.$message.error(res.msg)
            } else {
              if (this.checked) {
                // 记住密码
                if (user.email) {
                  setCookie('login_user', user.email, 7)
                  setCookie('login_p', user.password, 7)
                }
              } else {
                clearCookie('login_user')
                clearCookie('login_p')
              }
              this.$store.commit('setToken', { token: res.access_token, tokenExpires: new Date().getTime() + res.expires_in * 1000 })
              this.$store.commit('setPath', '/userlist')
              this.$router.replace('/userlist')
            }
          })
        } else {
          return false
        }
      })
    }

  }
}
</script>

<style lang="scss" scoped>
  @import "src/styles/mixin";

.login-container {
  min-width: 960px;
  height: 100vh;
  background: url('../assets/images/Radiometer_bg.png');
  background-size: 100vw 100vh;
  overflow: hidden;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  ::v-deep .el-input-group__prepend {
    background-color: #FFFFFF;
    padding: 0 0 0 16px;
  }
  ::v-deep .el-input__inner:focus {
    border-color: #DCDFE6;
  }
  ::v-deep .el-input__inner {
    border-left: none;
    padding: 0 8px;
  }
  .email-icon {
    width: 16px;
    height: 16px;
    margin-top: 4px;
  }
  .logo {
    position: absolute;
    right: 70px;
    top: 70px;
    width: 128px;
    height: 57px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .login-left-container {
    width: 50%;
    flex: 0 0 auto;
  }
  .login-right-container {
    width: 470px;
    height: 556px;
    background: #fff;
    border-radius: 8px;
    padding: 60px;
    box-sizing: border-box;
    > h1 {
      font-size: 32px;
      color: rgba(10, 67, 133, 1);
      padding: 0;
      margin: 0;
    }
    .login-right-info {
      margin-top: 50px;
      ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
        background-color: rgba(10, 67, 133, 1);
        border-color: rgba(10, 67, 133, 1);
      }
      ::v-deep .el-checkbox__input.is-focus .el-checkbox__inner {
        border-color: rgba(10, 67, 133, 1);
      }
      ::v-deep .el-checkbox__input.is-checked+.el-checkbox__label {
        color: rgba(10, 67, 133, 1);
      }
      .account {
        display: inline-block;
        font-size: 16px;
        color: #000;
        padding-bottom: 18px;
        margin-bottom: 30px;
        border-bottom: 2px solid rgba(10, 67, 133, 1);
        font-weight: 500;
      }
      .btn {
        margin-top: 30px;
        width: 100%;
        background: rgba(10, 67, 133, 1);
        border-radius: 3px;
      }
    }
  }
}
</style>
